import React, { useEffect } from 'react';
import { useCopyMode } from '../components/copy/copyMode';
import { IntroSplash } from '../components/IntroSplash';
import { MarketingHero } from '../components/MarketingHero';
import { AICoworkers } from '../components/AICoworkers';
import { HowItWorksConnections } from '../components/HowItWorksConnections';
import { LivesInSlack } from '../components/LivesInSlack';
import { ComputerUse } from '../components/ComputerUse';
import { CapabilityGrid } from '../components/CapabilityGrid';
import { QuickCapture } from '../components/QuickCapture';
import { NarrativeSection } from '../components/NarrativeSection';
import { ProductDemo } from '../components/ProductDemo';
import { ToolComparison } from '../components/ToolComparison';
import { WallOfLove } from '../components/WallOfLove';
import { PricingSection } from '../components/PricingSection';
import { ClosingCTA } from '../components/ClosingCTA';
// The original Giga marketing homepage, preserved verbatim and now served at
// /future while we explore a new home screen at "/".
export function FutureHome() {
  const {
    setMode
  } = useCopyMode();
  // /future is the canonical "current" Giga homepage — always show the AI
  // colleague / AI Co-pilot for Teams copy, regardless of the global toggle.
  useEffect(() => {
    setMode('current');
  }, [setMode]);
  return <>
      <IntroSplash data-id="element-4415" />
      <MarketingHero data-id="element-4416" />
      <AICoworkers data-id="element-4417" />
      {/* Unified dark "How it works + Connections" section. */}
      <HowItWorksConnections data-id="element-4418" />
      {/* "@mention Giga in any channel" — lands right after we've shown how
           Giga works and what it connects to. */}
      <LivesInSlack data-id="element-4419" />
      <ComputerUse data-id="element-4420" />
      {/* "Under the hood" capability grid — the proof beat right after the
           machine behind Giga (ComputerUse). */}
      <CapabilityGrid data-id="element-4421" />
      <QuickCapture data-id="element-4422" />
      {/* Founder quote sits between the two product-demo moments as a human
           narrative pause. */}
      <NarrativeSection data-id="element-4423" />
      <ProductDemo data-id="element-4424" />
      <ToolComparison data-id="element-4425" />
      <WallOfLove data-id="element-4426" />
      <PricingSection data-id="element-4427" />
      <ClosingCTA data-id="element-4428" />
    </>;
}